import { CSSObject } from '@emotion/react';
import { SlideInPosition } from '@shipengine/giger';

export const getSidePanelClipPathStyles = (position: SlideInPosition) => (): CSSObject => {
    return { clipPath: position === SlideInPosition.LEFT ? 'inset(0 -20px 0 0)' : 'inset(0 0 0 -20px)' };
};
